import { useEffect, useRef } from 'react';

import { PlayerProps } from '../types';

interface UseOnBeforeInitParams {
    onBeforeInit: PlayerProps['onBeforeInit'];
    isReadyToInit: boolean;
}

export const useOnBeforeInit = (params: UseOnBeforeInitParams) => {
    const { isReadyToInit, onBeforeInit = (): void => undefined } = params;
    const isInitStarted = useRef(false);

    useEffect(() => {
        if (!isInitStarted.current && isReadyToInit) {
            onBeforeInit();
            isInitStarted.current = true;
        }
    }, [isReadyToInit, onBeforeInit]);
};
